var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubprofile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.061 0 0 8.0595 0 18C0 25.953 5.157 32.7 12.3105 35.0805C13.209 35.247 13.5 34.689 13.5 34.215V30.864C8.493 31.953 7.4505 28.74 7.4505 28.74C6.6315 26.6595 5.451 26.106 5.451 26.106C3.8175 24.9885 5.5755 25.0125 5.5755 25.0125C7.383 25.1385 8.334 26.868 8.334 26.868C9.939 29.619 12.5445 28.824 13.572 28.3635C13.7325 27.201 14.199 26.406 14.715 25.9575C10.7175 25.5 6.5145 23.9565 6.5145 17.061C6.5145 15.0945 7.218 13.4895 8.3685 12.2295C8.1825 11.775 7.566 9.9435 8.544 7.4655C8.544 7.4655 10.056 6.9825 13.4955 9.3105C14.931 8.9115 16.47 8.712 18 8.7045C19.53 8.712 21.0705 8.9115 22.509 9.3105C25.9455 6.9825 27.4545 7.4655 27.4545 7.4655C28.434 9.945 27.8175 11.7765 27.6315 12.2295C28.7865 13.4895 29.484 15.096 29.484 17.061C29.484 23.9745 25.2735 25.497 21.2655 25.9425C21.9105 26.5005 22.5 27.5955 22.5 29.2755V34.215C22.5 34.6935 22.788 35.256 23.7015 35.079C30.849 32.6955 36 25.95 36 18C36 8.0595 27.9405 0 18 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubprofile);
export default __webpack_public_path__ + "static/media/githubprofile.6442c6ce4e2af8b0c052f223b33f2d20.svg";
export { ForwardRef as ReactComponent };